import { useMemo } from 'preact/hooks';
import { useChat, useRoomContext, useTranscriptions } from '@livekit/components-react';
import type { AiMessage } from 'server/types/cal-overrides';

export function useChatAndTranscription(initialMessages: AiMessage[]) {
  const transcriptions = useTranscriptions();
  const chat = useChat();
  const room = useRoomContext();

  const mergedMessages = useMemo(() => {
    const transcriptionMessages: AiMessage[] = transcriptions.map((t) => ({
      id: t.streamInfo.id,
      content: t.text,
      isAssistant: t.participantInfo.identity !== room.localParticipant.identity,
      timestamp: t.streamInfo.timestamp,
    }));

    const chatMessages: AiMessage[] = chat.chatMessages.map((c) => ({
      id: c.id,
      content: c.message,
      isAssistant: c.from?.identity !== room.localParticipant.identity,
      timestamp: c.timestamp,
    }));

    const merged = [...initialMessages, ...transcriptionMessages, ...chatMessages];
    return merged.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));
  }, [initialMessages, transcriptions, chat.chatMessages, room]);

  return { messages: mergedMessages, send: chat.send };
}
